
export const GENERATE_TOKEN = {
    REQUEST: 'USER.ACCESS_TOKEN.GENERATE_TOKEN.REQUEST',
    SUCCESS: 'USER.ACCESS_TOKEN.GENERATE_TOKEN.SUCCESS',
    FAILED: 'USER.ACCESS_TOKEN.GENERATE_TOKEN.FAILED',
};

export const CLEAR_STATE = 'COMMON.LOG.CLEAR_STATE';
